import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import clsx from "clsx";
import React from "react";
import { FaDownload } from "react-icons/fa";
import SectionTitle from "../layout/SectionTitle";
import { classes, StyledSectionWrapper } from "./styles";
import { PricingSectionProps } from "./props";
import { stripDiacritics } from "../../util/string";

const PricingSection = ({
  product,
  sectionId,
  priceFileName,
  productFileName,
  CalculatorComponent,
}: PricingSectionProps) => {
  const handleClick = (fileName: string) => (e: any) => {
    const link = document.createElement("a");
    link.download = fileName;
    link.href = `/files/${fileName}`;
    link.click();
  };

  console.log("button", {
    className: `button${stripDiacritics(product)}` as
      | "buttonAgenda"
      | "buttonAbsences"
      | "buttonBudget"
      | "buttonMetronome",
  });
  return (
    <StyledSectionWrapper sectionId={sectionId}>
      <Container className={classes.container}>
        <SectionTitle text="Tarifs" variant="innoGrey" />
        <div className={clsx(classes.subContainer)}>{CalculatorComponent}</div>
        <div className={clsx(classes.subContainer, classes.buttonContainer)}>
          <Button
            className={clsx(
              classes.button,
              classes[
                `button${stripDiacritics(product)}` as
                  | "buttonAgenda"
                  | "buttonAbsences"
                  | "buttonBudget"
                  | "buttonMetronome"
              ]
            )}
            startIcon={<FaDownload />}
            onClick={handleClick(productFileName)}
            variant="contained"
            size="large"
            aria-label="Télécharger la fiche produit"
          >
            Fiche produit Innovance {" " + product}
          </Button>
          <Button
            className={clsx(
              classes.button,
              classes[
                `button${stripDiacritics(product)}` as
                  | "buttonAgenda"
                  | "buttonAbsences"
                  | "buttonBudget"
                  | "buttonMetronome"
              ]
            )}
            startIcon={<FaDownload />}
            onClick={handleClick(priceFileName)}
            variant="contained"
            size="large"
            aria-label="Télécharger la fiche tarifs"
          >
            Fiche tarifs Innovance {" " + product}
          </Button>
        </div>
      </Container>
    </StyledSectionWrapper>
  );
};

export default PricingSection;
